var _regeneratorRuntime = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var reduceSamples = require('./utils/reduceSamples');

var breathe = require('./utils/breathe');

function process2Vals(vals, prop, k) {
  //If no 2 valid values, assign the first. This covers nulls too
  if (vals.length < 2) return vals[0] || null; //If number, calculate proportion
  else if (typeof vals[0] === 'number') return vals[0] + (vals[1] - vals[0]) * prop; //If date, calculate proportion
  else if (k === 'date') {
    return new Date(new Date(vals[0]).getTime() + (new Date(vals[1]).getTime() - new Date(vals[0]).getTime()) * prop); //If object (or more likely array) interpolate the sample properties recursively
  } else if (typeof vals[0] === 'object') {
    var result;

    try {
      result = JSON.parse(JSON.stringify(vals[0]));
    } catch (error) {
      result = vals[0];
    }

    for (var key in result) {
      result[key] = process2Vals([vals[0][key], vals[1][key]], prop);
    }

    return result; //If string or other, use the first valid value
  } else return vals[0];
} //Build one sample by interpolating the previous and the next


function interpolateSample(samples, i, currentTime) {
  var baseTime = samples[i].cts;
  var difference = samples[i + 1].cts - baseTime; //How much we need to move from i towards i+1

  var proportion = (currentTime - baseTime) / difference; //Get all unique keys

  var keys = new Set([samples[i], samples[i + 1]].reduce(function (acc, curr) {
    return acc.concat(Object.keys(curr));
  }, []));
  var result = Array.isArray(samples[0]) ? [] : {}; //Loop the keys

  keys.forEach(function (k) {
    var validVals = [samples[i], samples[i + 1]].map(function (s) {
      return s[k];
    }).filter(function (v) {
      return v != null;
    });
    result[k] = process2Vals(validVals, proportion, k);
  });
  return result;
} //Makes sure there is one sample per each specified time chunk


module.exports = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(klv, _ref) {
    var groupTimes, timeOut, disableInterpolation, disableMerging, result, key, k, samples, currentTime, newSamples, reachedEnd, i, group;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            groupTimes = _ref.groupTimes, timeOut = _ref.timeOut, disableInterpolation = _ref.disableInterpolation, disableMerging = _ref.disableMerging;

            try {
              result = JSON.parse(JSON.stringify(klv));
            } catch (error) {
              result = klv;
            } //Loop devices and streams


            _context.t0 = _regeneratorRuntime.keys(result);

          case 3:
            if ((_context.t1 = _context.t0()).done) {
              _context.next = 41;
              break;
            }

            key = _context.t1.value;

            if (!result[key].streams) {
              _context.next = 39;
              break;
            }

            _context.t2 = _regeneratorRuntime.keys(result[key].streams);

          case 7:
            if ((_context.t3 = _context.t2()).done) {
              _context.next = 39;
              break;
            }

            k = _context.t3.value;
            _context.next = 11;
            return breathe();

          case 11:
            //Gather samples
            samples = result[key].streams[k].samples;

            if (!samples) {
              _context.next = 37;
              break;
            }

            currentTime = 0;
            newSamples = [];
            reachedEnd = false;
            i = 0; //Loop until the end of the array

          case 17:
            if (reachedEnd) {
              _context.next = 36;
              break;
            }

            group = []; //Loop one time per each desired time chunk

          case 19:
            if (!(samples[i].cts < currentTime + groupTimes)) {
              _context.next = 31;
              break;
            }

            //Gather all the samples within that chunk
            group.push(samples[i]);

            if (!(i + 1 >= samples.length)) {
              _context.next = 26;
              break;
            }

            //Until the end is reached
            reachedEnd = true;
            return _context.abrupt("break", 31);

          case 26:
            i++;

          case 27:
            if (!disableMerging) {
              _context.next = 29;
              break;
            }

            return _context.abrupt("break", 31);

          case 29:
            _context.next = 19;
            break;

          case 31:
            //Decide wether to merge, copy or interpolate samples based on the amount found under the time chunk
            if (group.length > 1) newSamples.push(reduceSamples(group));else if (i > 0 && i < samples.length && !disableInterpolation) {
              newSamples.push(interpolateSample(samples, i - 1, currentTime));
            } else if (group.length === 1) newSamples.push(group[0]); //If cts was temporary, remove it

            if (timeOut === 'date' && newSamples.length) delete newSamples[newSamples.length - 1].cts; //Add time to analyse next chunk

            currentTime += groupTimes;
            _context.next = 17;
            break;

          case 36:
            //Replace samples with merged/interpolated ones
            result[key].streams[k].samples = newSamples;

          case 37:
            _context.next = 7;
            break;

          case 39:
            _context.next = 3;
            break;

          case 41:
            return _context.abrupt("return", result);

          case 42:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();